import * as bi from 'react-bootstrap-icons';
import { ClientPassengerDocumentStatus } from '@bustickus/models-client';
import { Flex } from 'components';
import './style.scss';
import classNames from 'classnames';

interface IProps {
  title: string;
  status: ClientPassengerDocumentStatus;
}

function PassengerDocument(props: IProps) {
  return (
    <Flex
      gap={5}
      className='passenger-doc-vyeRg'
    >
      <div className={classNames('doc-icon-YDqN', getStateClass(props.status))}>{getStateIcon(props.status)}</div>
      <Flex direction='column'>
        <div className={classNames('doc-title-rVQC', getStateClass(props.status))}>{props.title}</div>
        <div className='doc-description-l82K'>{getStateText(props.status)}</div>
      </Flex>
    </Flex>
  );
}

function getStateIcon(status: ClientPassengerDocumentStatus): React.ReactNode {
  if (status === 'ok') {
    return <bi.CheckLg />;
  }

  if (status === 'none') {
    return <bi.ExclamationLg />;
  }

  if (status === 'expired') {
    return <bi.ExclamationLg />;
  }

  return <bi.ExclamationLg />;
}

function getStateText(status: ClientPassengerDocumentStatus): string {
  if (status === 'ok') {
    return 'Документ заполнен корректно';
  }

  if (status === 'none') {
    return 'Документ отсутствует';
  }

  if (status === 'expired') {
    return 'Документ истекает';
  }

  return 'Статус документа неизвестен';
}

function getStateClass(status: ClientPassengerDocumentStatus): string {
  if (status === 'ok') {
    return 's-Xnoxq';
  }

  if (status === 'none') {
    return 'e-TWC27';
  }

  if (status === 'expired') {
    return 'e-TWC27';
  }

  return 'w-KDlQd';
}

export default PassengerDocument;
